/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const UserIcon = createIcon(
  '0 0 20 20',
  <path d="M6 6a4 4 0 1 1 4.516 3.967.02.02 0 0 0-.016.018q.002.016.018.019A7 7 0 0 1 16.613 14c.426.9.723 1.869 1.018 2.83.12.393.24.785.369 1.17H2c.128-.385.248-.777.369-1.17.295-.961.592-1.93 1.018-2.83a7 7 0 0 1 6.095-3.996.018.018 0 0 0 .002-.037A4 4 0 0 1 6 6" />,
);
